import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {SharedModule} from "@shared/shared.module";
import {FormsModule} from "@angular/forms";
import {PopoverModule} from "ngx-bootstrap/popover";
import {NgxSpinnerModule} from "ngx-spinner";
import { EcommerceRoutingModule } from './ecommerce-routing.module';
import { ProductListComponent } from './product-list/product-list.component';
import { CategoryListComponent } from './category-list/category-list.component';
import { OrderListComponent } from './order-list/order-list.component';
import { CreateproductComponent } from './createproduct/createproduct.component';
import { CategoryModalComponent } from './category-list/category-modal/category-modal.component';
import { OrderDetailsComponent } from './order-details/order-details.component';


@NgModule({
  declarations: [
  
    ProductListComponent,
       CategoryListComponent,
       OrderListComponent,
       CreateproductComponent,
       CategoryModalComponent,
       OrderDetailsComponent,
  ],
  imports: [
    CommonModule,
    EcommerceRoutingModule,
    SharedModule,
    FormsModule,
    PopoverModule,
    NgxSpinnerModule
  ]
})
export class EcommerceModule { }

